import React from 'react';
import { Link } from 'react-router-dom';
import "./OnBoarding.css"

function ThanksForSigningUp() {
  return (
    <div className='page-content' style={{ width: '100%', flexDirection: 'column' }}>
      <div className='page-title'>
        Invite Requested!
      </div>

      <div className="waitlist-section">
        Look out for an email from us soon!
      </div>

      <div className="waitlist-section">
        <Link to="/">Go Back to Home</Link>
      </div>
    </div>
  );
}

export default ThanksForSigningUp;
